import { List, Map } from 'immutable'
import { CLEAR_HTTP_STATUS, GET_UNASSIGNED_CONSIGNMENT_EVENTS } from '../actions/actionTypes'
import { ConsignmentIdType } from '../types/coreEntitiesTypes'

const initialState = Map()

interface UnassignedConsignmentEventsAction {
  type:
    | typeof GET_UNASSIGNED_CONSIGNMENT_EVENTS.REQUEST
    | typeof GET_UNASSIGNED_CONSIGNMENT_EVENTS.SUCCESS
    | typeof CLEAR_HTTP_STATUS
  body?: { unassignedEvents?: ConsignmentIdType[] }
  params?: {
    ids: List<ConsignmentIdType>
  }
  httpStatuses?: string[]
}

export default function reducer(state = initialState, action: UnassignedConsignmentEventsAction) {
  switch (action.type) {
    case GET_UNASSIGNED_CONSIGNMENT_EVENTS.REQUEST: {
      return state.delete('consignmentIds')
    }
    case GET_UNASSIGNED_CONSIGNMENT_EVENTS.SUCCESS: {
      if (!action.body) {
        return state
      }
      return state.set('consignmentIds', List(action.body.unassignedEvents ?? []))
    }
    case CLEAR_HTTP_STATUS: {
      if (action.httpStatuses?.includes(GET_UNASSIGNED_CONSIGNMENT_EVENTS.name)) {
        return state.delete('consignmentIds')
      }
      return state
    }
    default:
      return state
  }
}
